<!-- sgi/apps/frontend/ui-enrollment/src/App.vue -->
<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<<template>
  <RouterView />
</template>